var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat-history',{ref:"chatHistory",attrs:{"messages":_vm.messages,"displayID":_vm.displayID}})}
var staticRenderFns = []

export { render, staticRenderFns }